<template>
  <a
    class="btn-sidebar btn btn-primary shadow-sm rounded-5 p-3 p-md-4"
    href="/files/pdf/Scol_Folder_A4_2026_webversion.pdf?v=2"
    target="_blank"
    title="SCOL Programm 2026/2027"
  >
    Programm
    <br />
    2026/27
  </a>
  <footer id="footer">
    <a href="#app" class="scroll-top">
      <i class="fas fa-chevron-up"></i>
    </a>
    <div class="container footer-top text-white">
      <div class="row">
        <div class="col-md-6">
          <h3>Kontakt</h3>
          <p class="mb-2">
            Wenn du Fragen hast, einen Rückruf wünscht oder ein Angebot zugeschickt bekommen möchtest, dann melde dich!
          </p>
          <p class="mb-0">
            <i class="far fa-clock me-2"></i>
            Mo–Fr von 09:00 bis 17:00 Uhr sind wir für dich da.
          </p>
          <div class="mt-4">
            <a
              :href="$route('contact')"
              role="button"
              class="btn btn-outline-white rounded-pill me-2 mb-4"
            >
              <i class="far fa-file-alt me-2"></i> Kontaktformular
            </a>
            <a
              href="tel:+49443596000"
              role="button"
              class="btn btn-outline-white rounded-pill mb-4"
            >
              <i class="fas fa-phone-alt me-2"></i> Anrufen
            </a>
          </div>
          <ul class="nav flex-column footer-inquiry-links">
            <li class="nav-item">
              <a class="nav-link ps-0" :href="$route('group-travel')">
                <i class="fas fa-users me-2"></i> Gruppenreisen 26/27 (ab 8 Personen)
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link ps-0" :href="$route('future-destinations')">
                <i class="fas fa-map-marked-alt me-2"></i> Zukünftige Reiseziele 27/28
              </a>
            </li>
          </ul>
        </div>
        <div
          class="col-md-6 d-md-none d-flex justify-content-start justify-content-md-center my-4"
        >
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x text-white"></i>
            <i class="fab fa-facebook-f fa-stack-1x fa-inverse"></i>
          </span>
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x text-white"></i>
            <i class="fab fa-instagram fa-stack-1x fa-inverse"></i>
          </span>
        </div>
        <div class="col-md-6 d-flex justify-content-md-end">
          <div class>
            <h3>Mehr von Scol</h3>
            <ul id="scol-nav" class="nav flex-column">
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="https://scol-sporthotel-zillertal.at/"
                  target="_blank"
                >
                  <img
                    :src="$page.props.page.assets.logo_zillertal"
                    alt="SCOL Sporthotel Zillertal"
                  />
                  SCOL Sporthotel Zillertal
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="https://scol-sporthotel.com/"
                  target="_blank"
                >
                  <img
                    :src="$page.props.page.assets.logo_grossglockner"
                    alt="SCOL Sporthotel Großglockner"
                  />
                  SCOL Sporthotel Großglockner
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="https://kempermann.com/"
                  target="_blank"
                >
                  <img
                    :src="$page.props.page.assets.logo_kempermann"
                    alt="Gasthaus Kempermann"
                  />
                  Gasthaus Kempermann
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div
          class="col-lg-3 d-lg-block d-md-flex d-none justify-content-center mb-lg-0 mb-3"
        >
          <a
            href="https://www.facebook.com/scol.skireisen"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x text-white"></i>
              <i class="fab fa-facebook-f fa-stack-1x fa-inverse"></i>
            </span>
          </a>
          <a
            href="https://www.instagram.com/scol_skireisen/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x text-white"></i>
              <i class="fab fa-instagram fa-stack-1x fa-inverse"></i>
            </span>
          </a>
        </div>
        <div class="col-lg-9 d-flex align-items-center justify-content-end">
          <ul id="info-nav" class="nav">
            <!-- <li class="nav-item">
                <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#larativo-member-login-modal" onclick="event.preventDefault;">Login-Bereich</a>
              </li> -->
            <li class="nav-item">
              <a class="nav-link" :href="$route('about-us')">Über Uns</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="$route('insurances')"
                >Versicherungen</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="$route('conditions')">AGB</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="$route('legal-notice')">Impressum</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="$route('data-protection')"
                >Datenschutz</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link open-cookie-modal-settings" href="#">Cookie Einstellungen</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container footer-bottom">
      <p>&copy; {{ new Date().getFullYear() }} SCOL Skireisen</p>
    </div>
  </footer>
</template>
